/**
 * Updates filename based on displayname if they differ
 * @param {string} filename - Original filename (e.g., "myname_cos_123456.txt")
 * @param {string} displayname - Display name to use as new filename
 * @returns {string} - Updated filename or original if no change needed
 */
export const updateFilenameFromDisplayname = (filename, displayname) => {
  if (!displayname || !filename) {
    return filename;
  }

  // Extract the actual name from filename (remove _cos_XXXXXX part)
  const cosMatch = filename.match(/^(.+?)(_cos_\d+)(\..+)?$/);

  if (cosMatch) {
    const actualName = cosMatch[1];
    // const cosIdentifier = cosMatch[2]; // not used
    const extension = cosMatch[3] || '';

    // If displayname is different from actual name, replace the entire filename
    if (actualName !== displayname) {
      return displayname + extension;
    }
  } else {
    // For files without _cos_ pattern, extract extension and replace with displayname
    const extensionMatch = filename.match(/(\..+)$/);
    const extension = extensionMatch ? extensionMatch[1] : '';
    const actualName = extensionMatch
      ? filename.replace(extensionMatch[1], '')
      : filename;

    // If displayname is different from actual name, replace the filename
    if (actualName !== displayname) {
      return displayname + extension;
    }
  }

  return filename;
};

